// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3TDH{flex:1}.k5bk{display:none}._3N3Q{background:#fff;width:100%;border:1px solid #000}._2Yba{position:relative;padding:.4rem 3rem .4rem 3.5rem;height:3.2rem;background:#373737;color:#fff;cursor:pointer}._2Yba p{overflow:hidden;text-overflow:ellipsis}@media (min-width:62em){._2Yba p{white-space:nowrap}}.RcIL{position:absolute;width:1.8rem;height:1.8rem;top:0;bottom:0;margin:auto}._1ll_{left:1rem}._2tao{right:1rem}@media (max-width:61.9375em){._2tao{right:3.5rem;background:#373737}}html[dir=rtl] ._2Yba{padding:.4rem 3.5rem .4rem 3rem}html[dir=rtl] ._1ll_{left:auto;right:1rem}html[dir=rtl] ._2tao{right:auto;left:1rem}@media (max-width:61.9375em){html[dir=rtl] ._2tao{right:auto;left:3.5rem}}", ""]);
// Exports
exports.locals = {
	"upload": "_3TDH",
	"input": "k5bk",
	"button": "_3N3Q",
	"state": "_2Yba",
	"icon": "RcIL",
	"file": "_1ll_",
	"close": "_2tao"
};
module.exports = exports;
